// extracted by mini-css-extract-plugin
export default {"root":"QuizProgressBarV4_root-EUn","fill":"QuizProgressBarV4_fill-Zgg"};